var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"opacity":"1","dark":"","color":_vm.$vuetify.theme.dark ? 'black' : 'white'},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}},[_c('span',[_c('v-img',{attrs:{"src":require("../assets/fadestaggersquares-loader.svg"),"sizes":"350"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }